import React from 'react';
import Badge from './ui/Badge';
import Icons from './Icons';
import { formatDate } from '../utils/dateFormat';

export default function AttendancePanel({ attendance }) {
  const weeks = attendance.last8Weeks || [];
  const logs = attendance.logs || [];
  const statusBadge = {
    attended: 'active',
    'partially attended': 'review',
    disrupted: 'warning',
    'session stopped': 'danger',
    late: 'review',
    'authorised absence': 'inactive',
    'unauthorised absence': 'danger'
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="sp-value" style={{ fontSize: '16px', fontWeight: 600 }}>Attendance</h3>
        <Badge variant={attendance.rate < 70 ? 'danger' : attendance.rate < 85 ? 'review' : 'active'}>
          {attendance.rate}%
        </Badge>
      </div>

      <div className="sp-chart">
        <div className="flex items-center justify-between mb-3">
          <p className="text-sm sp-muted">Last 8 weeks trend</p>
          <div className="flex items-center gap-1 text-sm sp-muted">
            {attendance.trend === 'improving' && (
              <span className="inline-flex items-center gap-1">
                <Icons.TrendUp /> Improving
              </span>
            )}
            {attendance.trend === 'declining' && (
              <span className="inline-flex items-center gap-1">
                <Icons.TrendDown /> Declining
              </span>
            )}
            {attendance.trend === 'stable' && <span>Stable</span>}
          </div>
        </div>
        <div className="grid grid-cols-8 gap-2 items-end h-20">
          {weeks.map((week, idx) => (
            <div key={idx} className="flex flex-col items-center gap-1">
              <div
                className="w-full sp-chart-bar"
                style={{ height: `${Math.max(12, week)}%` }}
                title={`${week}%`}
              />
              <span className="text-[10px] sp-muted">{idx + 1}</span>
            </div>
          ))}
        </div>
      </div>

      <div>
        <h4 className="sp-label">Attendance log</h4>
        {logs.length ? (
          <div className="space-y-2 mt-2">
            {logs.slice(0, 6).map((log, idx) => (
              <div key={log.id || idx} className="sp-panel sp-panel--muted p-3 flex items-center justify-between gap-2 flex-wrap">
                <div>
                  <div className="text-sm sp-value" style={{ fontWeight: 600 }}>
                    {log.status}
                  </div>
                  <div className="text-xs sp-muted">
                    {formatDate(log.date)}{log.programme ? ` · ${log.programme}` : ''}{log.notes ? ` · ${log.notes}` : ''}
                  </div>
                </div>
                <Badge variant={statusBadge[log.status] || 'info'}>{log.status}</Badge>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-sm sp-muted mt-2">No attendance logs yet.</div>
        )}
      </div>

      <div>
        <h4 className="sp-label">Absence reasons</h4>
        {attendance.absenceReasons?.length ? (
          <div className="space-y-2">
            {attendance.absenceReasons.map((reason, idx) => (
              <div key={idx} className="sp-panel sp-panel--muted p-3">
                <p className="text-sm sp-value">{reason.reason}</p>
                <p className="text-xs sp-muted">{formatDate(reason.date)}</p>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-sm sp-muted">No recorded absences.</div>
        )}
      </div>
    </div>
  );
}
